module.exports = __webpack_public_path__ + "img/pr-2.3778b204.png";